import React, { useEffect } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useInstitutionsReauthorization } from "@/features/accounts/shared/hooks/use-institutions-reauthorization";
import { useInstitutionsServices } from "@/features/institutions/hooks/use-institutions-services";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { SimpleForm } from "@/shared/components/text-box/simple-form";


interface Props {
  onTapCloseModal: () => void;
}

// 金融機関再認可モーダル
export const InstitutionsReauthorizationModal = (props: Props) => {
  const {
    onTapCloseModal,
  } = props;
  const {
    authType,
    selectedInstitutionService,
    setSelectedInstitutionService,
  } = useInstitutionsContext();
  const { 
    requestInstitutionsReauthorizationSite,
  } = useInstitutionsReauthorization();
  const {
    selectedAccount,
  } = useAccountGroupsContext();
  const {
    getInstitutionsServices,
  } = useInstitutionsServices();

  // 選択ボタンに付与するID
  const institutionsReauthorization = "institutions_reauthorization";

  useEffect(() => {
    const fetchData = async () => {
      if (selectedAccount?.passbookType === "01" || selectedAccount?.passbookType === "03" || selectedAccount?.passbookType === "10" || selectedAccount?.passbookType === "19659" || selectedAccount?.passbookType === "19660") {
        const resService = await getInstitutionsServices(
          selectedAccount?.industryCode || "",
          selectedAccount?.companyCode || "",
          selectedAccount?.branchCode || "",
        );
        // resからcompany_codeとservice_codeとbranch_codeに合致するものを見つけて、コンテキストに保存する
        const selectedService = resService?.find(
          service => service.companyCode === selectedAccount?.companyCode &&
          service.serviceCode === selectedAccount?.serviceCode &&
          service.branchCode === selectedAccount?.branchCode
        );
        setSelectedInstitutionService(selectedService || undefined);
      }
    };
    fetchData();
  }, []);

  //  遷移ボタン選択時
  const handleSelect = () => {
    // 金融機関認可サイトへ遷移
    requestInstitutionsReauthorizationSite();
  }

  const getAuthType = () => {
    if (authType === "bank") {
      return "銀行";
    } else if (authType === "crecaApi" || authType === "crecaLookScrape" || authType === "crecaLookApi") {
      return "カード";
    } else if (authType === "emoneyLookScrape" || authType === "emoneyLookApi") {
      return "電子マネー";
    } else if (authType === "ecshop") {
      return "その他連携サービス";
    }
  }
  const institutionType = () => {
    if (authType === "bank") {
      return "bank";
    } else if (authType === "crecaApi" || authType === "crecaLookScrape" || authType === "crecaLookApi") {
      return "card";
    } else if (authType === "emoneyLookScrape" || authType === "emoneyLookApi") {
      return "ev";
    } else if (authType === "ecshop") {
      return "other";
    }
  }

  // selectedInstitutionServiceから会社名、サービス名、支店名を取得する
  const companyName = selectedInstitutionService?.companyName || "";
  const serviceName = selectedInstitutionService?.serviceName || "";
  const branchName = selectedInstitutionService?.branchName || "";
  const institutionName = companyName + (branchName !== "" ? " " + branchName : "");

  return (
    <BasePageModal
      title="認証情報の変更"
      className={`md-add-bank ${institutionType()}`}
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText={`${institutionName}のサイトへ移動`}
          onClick={() => handleSelect()}
          id={institutionsReauthorization}
          loadingNegative={true}
        />
      }
    >
      <h2>
        金融機関の認証サイトへ移動します
      </h2>
      <dl>
        <SimpleForm
          id="companyName"
          value={institutionName}
          isReadOnly={true}
          title="金融機関"
          onChange={() => {}}
          labelEnable={true}
          descriptionType={true}
        />
        <SimpleForm
          id="serviceName"
          value={serviceName}
          isReadOnly={true}
          title="サービス"
          onChange={() => {}}
          labelEnable={true}
          descriptionType={true}
        />
      </dl>
      <div className="notice">
        <p>
          上記で口座再認証を開始します。<br />
          金融機関サイトで再認証を行ってください。
        </p>
      </div>
    </BasePageModal>
  );
};